import React, { useRef } from 'react'
import ReactDOM from 'react-dom'
import xclose from '../assets/xclose.png'
import logo from '../assets/DigitalContacts-logo.svg'
import { DEFAULT_AVATAR, handleAvatarError } from '../utils/imageFallback'
var QRCode = require('qrcode.react')

// Printable resolution, not the small on-screen display size -- a QR
// exported at the popup's own size is unusable the moment anyone
// prints it.
const DOWNLOAD_SIZE = 1024

export default function QrScan({ user, show, setshow }) {
  // qrcode.react's default export is a plain function component (not
  // forwardRef), so a ref can't reach its internal <canvas> directly --
  // querying for it inside a wrapper ref is the reliable way to get the
  // actual canvas node back out.
  const downloadQrRef = useRef(null)
  const qrValue = `${window.location.origin}/${user.lengthId}`

  const handleDownload = () => {
    const canvas = downloadQrRef.current && downloadQrRef.current.querySelector('canvas')
    if (!canvas) return

    // PNG, not JPEG -- JPEG's lossy compression softens the sharp
    // black/white edges QR scanners depend on.
    const link = document.createElement('a')
    link.href = canvas.toDataURL('image/png')
    link.download = `${user.userName || user.lengthId}-digital-contact-card.png`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  // Portaled to document.body -- position:fixed is normally viewport-
  // relative regardless of DOM nesting, but an ancestor with its own
  // transform/overflow context can trap it instead (see NavMenu.js's
  // own comment on the identical problem its slide-in panel hit). Now
  // that this renders on more than just Dashboard.js (see AppTopBar.js),
  // it needs the same escape hatch NavMenu already uses, not just
  // whichever page happens to have simple-enough ancestors today.
  return ReactDOM.createPortal(
    <div>
      <div className={`col-12 ${show}`} id="profileQrCon">
        <div className="col-12 text-right pt-4 p-0" onClick={() => setshow('')}>
          <img
            src={xclose}
            width="25"
            className="clsPopup"
            target="#profileQrCon"
            alt="QR CODE"
          />
        </div>
        <div className="col-12 r2 text-center">
          <div className="my-profile-photo">
            <img
              src={user.avatarUrl || DEFAULT_AVATAR}
              alt="Avatar"
              id="profileImg"
              onError={handleAvatarError}
            />
          </div>
          <div className="col-12 p-2">
            <h1>
              <b>{user.name}</b>
            </h1>
          </div>
        </div>

        <div className="col-12 text-center r3" width="200">
          <QRCode value={qrValue} />
        </div>

        <div className="col-12 text-center r4">
          <b>Scan this code with a camera</b>
          <br />
          <b>to share your Digital Contact Card.</b>
        </div>

        <div className="col-12 text-center my-2">
          {/* Deliberately not .btn -- that class is a full-width, block-
              level, heavy-weight primary button (used for Add to
              Contacts etc.), which is wrong here: this is a secondary
              action relative to the QR code itself, so it's sized and
              styled to sit quietly underneath it instead. */}
          <button
            type="button"
            onClick={handleDownload}
            style={{
              display: 'inline-block',
              padding: '10px 20px',
              fontSize: '13px',
              fontWeight: 600,
              color: '#000001',
              background: '#ffffff',
              border: '1px solid #d0d0d0',
              borderRadius: '20px',
              cursor: 'pointer',
            }}
          >
            Download QR code
          </button>
        </div>

        <div className="col-12 text-center r5">
          <img src={logo} width="100" alt="LOGO" />
          <div>
            {/* Same URL the QR code itself encodes (qrValue) -- built
                from window.location.origin, not a hardcoded domain, so
                this points at wherever the app is actually running
                (staging vs. production) instead of always production.
                Visible text is just the lengthId, not the full URL. */}
            <a
              href={qrValue}
              style={{
                display: 'inline-block',
                marginTop: '4px',
                fontSize: '12px',
                color: '#0000EE',
                textDecoration: 'none',
              }}
            >
              {user.lengthId}
            </a>
          </div>
        </div>
      </div>

      {/* Off-screen, high-resolution, QR-only render used solely as the
          download source -- kept out of the visible popup (which stays
          small and includes the name/caption/logo) and out of layout
          entirely, but still a real rendered canvas so toDataURL works. */}
      <div
        ref={downloadQrRef}
        style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
        aria-hidden="true"
      >
        <QRCode value={qrValue} size={DOWNLOAD_SIZE} includeMargin />
      </div>
    </div>,
    document.body
  )
}
